import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { ROUTE_PATHS } from '@smata-data-shared';
import { AuthSessionStorage } from './auth-session.storage';

export const authGuard: CanActivateFn = (route, state) => {
  const router = inject(Router);

  const token = AuthSessionStorage.getToken();

  if (token) {
    return true;
  }

  router.navigate([ROUTE_PATHS.login], { queryParams: route.queryParams });
  return false;
};
